import React, { useState, useEffect, useContext } from "react";
import { isMobile } from "react-device-detect";
import dayjs from "dayjs";

import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";
import ReplyIcon from "@mui/icons-material/Reply";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

// Bootstrap
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// My Files
import UserAvatar from "../../management/UserAvatar";
import CommentInput from "./CommentInput";
import firebase from "../../../firebase";
import { UserContext } from "../../../context";
import { isNumeric, makeid } from "../../../utility";
import ConfirmDeleteDialog from "../../ConfirmDeleteDialog";
import CommentEditForm from "../../CommentEditForm";

const COMMENT_EDITING_ENABLED = false;

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: 10,
        width: "100%",
    },
    nameText: {
        ...theme.typography.bodyBold,
        paddingLeft: 15,
    },
    dateText: {
        color: theme.palette.text.secondary,
        paddingLeft: 5,
    },
    textColumn: {
        paddingLeft: (props) => (props.avatarSize === "small" ? 25 : 30),
    },
    textRow: {
        paddingLeft: 15,
    },
    replyPadding: {
        paddingLeft: 35,
    },
    replyButton: {
        maxWidth: 25,
        minWidth: 25,
    },
    moreButton: {
        width: 30,
        height: 30,
    },
}));

export default function FileComment(props) {
    const classes = useStyles(props);
    const [time, setTime] = useState(Date.now()); // Updates the comments periodically so their dateString stays current (e.g. 5 minutes ago)

    const [dateString, setDateString] = useState("");

    const [isReplying, setIsReplying] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editText, setEditText] = useState("");
    const [isSavingEdit, setIsSavingEdit] = useState(false);
    const [isHovering, setIsHovering] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] =
        useState(false);

    const [segments, setSegments] = useState([]); // Segments either containing text or time links

    const { currentUserData } = useContext(UserContext);

    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), 5000);

        // Get the comment date and determine the largest non-zero time interval (e.g. if the comment was 1 month 6 days ago, we want '1 month' as the result)
        let commentDate = dayjs(props.comment.date);
        let now = dayjs();

        let diffs = [
            {
                interval: "years",
                value: now.diff(commentDate, "years"),
            },
            {
                interval: "months",
                value: now.diff(commentDate, "months"),
            },
            {
                interval: "weeks",
                value: now.diff(commentDate, "weeks"),
            },
            {
                interval: "days",
                value: now.diff(commentDate, "days"),
            },
            {
                interval: "hours",
                value: now.diff(commentDate, "hours"),
            },
            {
                interval: "minutes",
                value: now.diff(commentDate, "minutes"),
            },
        ].filter((diff) => diff.value > 0);

        if (diffs.length === 0) {
            props.comment.dateString = "a moment ago";
            setDateString(props.comment.dateString);
        } else {
            let diff = diffs[0];

            if (diff.value === 1) {
                props.comment.dateString =
                    diff.value + " " + diff.interval.replace("s", "") + " ago ";
                setDateString(props.comment.dateString);
            } else {
                props.comment.dateString =
                    diff.value + " " + diff.interval + " ago ";
                setDateString(props.comment.dateString);
            }
        }

        // Split message up into strings and link prefixed by @

        let segments = [];

        // const timestamps = findTimestamps(props.comment.text);
        //

        // if (timestamps.length > 0) {
        //     console.log(timestamps);
        //     timestamps.forEach((timestamp) => {
        //         let seperate = props.comment.text.split(timestamp);
        //         // console.log(seperate);
        //     });

        //     segments.push({ text: props.comment.text, isLink: false });
        // } else {
        //     segments.push({ text: props.comment.text, isLink: false });
        // }
        //
        props.comment.text.split("@").forEach((segment) => {
            segments.push({
                text: segment,
                isLink: isTimestamp(segment),
            });
        });

        setSegments(segments);

        return () => {
            clearInterval(interval);
        };
    }, [props.comment, time]);

    // function findTimestamps(string) {
    //     let stamps = [];

    //     // check for timestamps over an hour first
    //     const regex1 = RegExp(/([0-9]+):([0-9]+):([0-9]+)/, "g");
    //     let array1;

    //     var stringWithoutHourStamps = string;

    //     while ((array1 = regex1.exec(string)) !== null) {
    //         stamps.push(array1[0]);

    //         stringWithoutHourStamps = stringWithoutHourStamps.replace(
    //             array1[0],
    //             ""
    //         );
    //     }

    //     // Now check for timestamps under an hour
    //     const regex2 = RegExp(/([0-9]+):([0-9]+)/, "g");
    //     let array2;

    //     while ((array2 = regex2.exec(stringWithoutHourStamps)) !== null) {
    //         // console.log(
    //         //     `Found ${array2[0]}. Next starts at ${regex2.lastIndex}.`
    //         // );
    //         stamps.push(array2[0]);
    //     }

    //     return stamps;
    // }

    function isTimestamp(string) {
        // It's a timestamp if it contains a colon and no letters

        // const regExp1 = /([0-9]+):([0-9]+)/;
        // const match1 = string.match(regExp1);

        // if (match1 === string) {
        //     return true;
        // }

        // const regExp2 = /([0-9]+):([0-9]+):([0-9]+)/;
        // const match2 = string.match(regExp2);

        // if (match2 === string) {
        //     // return true;
        // }

        const regExp = new RegExp(/[a-zA-Z]/g);

        if (string.includes(":")) {
            if (!regExp.test(string)) {
                let segments = string.split(":");

                if (segments.length === 2) {
                    let minutes = segments[0];
                    let seconds = segments[1];

                    if (isNumeric(minutes) && isNumeric(seconds)) {
                        return true;
                    }
                } else if (segments.length === 3) {
                    let hours = segments[0];
                    let minutes = segments[1];
                    let seconds = segments[2];

                    if (
                        isNumeric(hours) &&
                        isNumeric(minutes) &&
                        isNumeric(seconds)
                    ) {
                        return true;
                    }
                }

                return true;
            }
        }

        return false;
    }

    function segmentsFromText(text) {
        return text.split("@").map((segment) => ({
            text: segment,
            isLink: isTimestamp(segment),
        }));
    }

    function handleReplyClick() {
        setIsReplying(true);
    }

    function closeReplyInput() {
        setIsReplying(false);
    }

    function onMouseEnter() {
        if (props.comment.user === currentUserData.key) {
            setIsHovering(true);
        }
    }

    function onMouseLeave() {
        setIsHovering(false);
    }

    const handleMenuClick = (event) => {
        setMenuOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleDeleteButtonPress = () => {
        handleMenuClose();
        setConfirmDeleteDialogOpen(true);
    };

    const handleEditButtonPress = () => {
        handleMenuClose();
        setIsReplying(false);
        setEditText(props.comment.text);
        setIsEditing(true);

        if (props.setIsTyping) {
            props.setIsTyping(true);
        }
    };

    const handleCancelEdit = () => {
        setEditText(props.comment.text);
        setIsEditing(false);

        if (props.setIsTyping) {
            props.setIsTyping(false);
        }
    };

    const handleAddTimestampToEdit = () => {
        const player = props.videoPlayer?.current;

        if (!player || typeof player.getCurrentTime !== "function") {
            return;
        }

        const currentTime = Math.max(0, Math.floor(player.getCurrentTime()));

        if (!Number.isFinite(currentTime)) {
            return;
        }

        const hours = Math.floor(currentTime / 3600);
        const minutes = Math.floor((currentTime % 3600) / 60);
        const seconds = currentTime % 60;
        const paddedSeconds = String(seconds).padStart(2, "0");
        const timestamp =
            hours > 0
                ? `${hours}:${String(minutes).padStart(
                      2,
                      "0",
                  )}:${paddedSeconds}`
                : `${minutes}:${paddedSeconds}`;

        setEditText((currentText) => {
            const separator =
                currentText.length > 0 && !/\s$/.test(currentText) ? " " : "";

            return `${currentText}${separator}@${timestamp}@ `;
        });
    };

    const handleSaveEdit = async () => {
        if (
            editText.trim() === "" ||
            props.comment.user !== currentUserData?.key
        ) {
            return;
        }

        setIsSavingEdit(true);

        try {
            await firebase
                .database()
                .ref("comments/" + props.comment.key)
                .update({ text: editText });

            props.comment.text = editText;
            setSegments(segmentsFromText(editText));
            setIsEditing(false);

            if (props.setIsTyping) {
                props.setIsTyping(false);
            }
        } catch (error) {
            console.error("Error updating comment:", error);
        } finally {
            setIsSavingEdit(false);
        }
    };

    const handleDeleteDialogClose = (shouldDelete) => {
        setConfirmDeleteDialogOpen(false);

        if (!shouldDelete) {
            return;
        }

        // Only this comment goes. Replies belong to their own authors, so the
        // thread survives and this comment renders as a placeholder to hold it
        // together. See CommentSection for when that placeholder is shown.
        let commentRef = firebase
            .database()
            .ref("comments/" + props.comment.key);

        commentRef.update({ deleted: true });
    };

    function handleSeekClick(text) {
        let components = text.split(":");

        if (components.length === 2) {
            let minutes = Number(components[0]);
            let seconds = Number(components[1]);

            if (minutes !== undefined && seconds !== undefined) {
                let totalSeconds = minutes * 60;
                totalSeconds += seconds;

                // props.videoPlayer.current.currentTime = totalSeconds; // For React-Hls-Player
                props.videoPlayer.current.seekTo(totalSeconds, "seconds");
            }
        } else if (components.length === 3) {
            let hours = Number(components[0]);
            let minutes = Number(components[1]);
            let seconds = Number(components[2]);

            if (
                hours !== undefined &&
                minutes !== undefined &&
                seconds !== undefined
            ) {
                let totalSeconds = hours * 3600;
                totalSeconds += minutes * 60;
                totalSeconds += seconds;

                props.videoPlayer.current.seekTo(totalSeconds, "seconds");
            }
        }
    }

    const canManageComment =
        currentUserData && props.comment.user === currentUserData.key;

    // A deleted comment only reaches this component when replies outlived it,
    // so it renders as an anonymous placeholder: no author, no text, and none
    // of the actions. The date stays so the thread still reads in order.
    const isDeleted = props.comment.deleted === true;
    const deletedLabel = "(Deleted) by Unknown User";

    if (props.modern) {
        return (
            <Box
                sx={{
                    width: "100%",
                    pb: props.showDivider ? 2 : 0,
                    mb: props.showDivider ? 2 : 0,
                    borderBottom: props.showDivider ? "1px solid" : "none",
                    borderColor: "divider",
                }}
            >
                {isDeleted ? (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "baseline",
                            flexWrap: "wrap",
                            columnGap: 0.75,
                            width: "100%",
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.disabled",
                                fontStyle: "italic",
                            }}
                        >
                            {deletedLabel}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{ color: "text.disabled" }}
                        >
                            {dateString}
                        </Typography>
                    </Box>
                ) : (
                <Box
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1.25,
                        width: "100%",
                    }}
                >
                    <Box sx={{ flexShrink: 0 }}>
                        <UserAvatar
                            userOrHub={props.comment.userObject}
                            size={props.avatarSize}
                            path="users"
                        />
                    </Box>

                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "baseline",
                                flexWrap: "wrap",
                                columnGap: 0.75,
                                mb: 0.35,
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    color: "text.primary",
                                    fontWeight: 800,
                                    lineHeight: 1.3,
                                }}
                            >
                                {props.comment.author}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{ color: "text.secondary" }}
                            >
                                {dateString}
                            </Typography>
                        </Box>

                        {isEditing ? (
                            <CommentEditForm
                                value={editText}
                                onChange={setEditText}
                                onCancel={handleCancelEdit}
                                onSave={handleSaveEdit}
                                onAddTimestamp={
                                    props.videoPlayer
                                        ? handleAddTimestampToEdit
                                        : undefined
                                }
                                onTimestampClick={
                                    props.videoPlayer
                                        ? handleSeekClick
                                        : undefined
                                }
                                isSaving={isSavingEdit}
                            />
                        ) : (
                            <Box
                                sx={{
                                    color: "text.primary",
                                    overflowWrap: "anywhere",
                                    lineHeight: 1.55,
                                }}
                            >
                                {segments.map((segment, index) => (
                                    <TextOrLink
                                        key={`${props.comment.key}-${index}`}
                                        modern
                                        isLink={segment.isLink}
                                        text={segment.text}
                                        handleSeekClick={handleSeekClick}
                                    />
                                ))}
                            </Box>
                        )}

                        {!props.isReply && !isEditing && (
                            <Button
                                size="small"
                                startIcon={<ReplyIcon />}
                                onClick={handleReplyClick}
                                sx={{
                                    mt: 0.25,
                                    ml: -1,
                                    minWidth: 0,
                                    color: "text.secondary",
                                }}
                            >
                                Reply
                            </Button>
                        )}
                    </Box>

                    {canManageComment && !isEditing && (
                        <IconButton
                            aria-label="Comment actions"
                            onClick={handleMenuClick}
                            size="small"
                            sx={{
                                mt: -0.5,
                                mr: -0.75,
                                color: "text.secondary",
                                opacity:
                                    isHovering || menuOpen || isMobile
                                        ? 1
                                        : 0.42,
                                transition: "opacity 150ms ease",
                            }}
                        >
                            <MoreVertIcon fontSize="small" />
                        </IconButton>
                    )}
                </Box>
                )}

                {isReplying && (
                    <Box
                        sx={{
                            ml: { xs: 2, sm: 6.25 },
                            mt: 1.25,
                            p: 1.5,
                            borderRadius: 2,
                            backgroundColor: "background.subtle",
                        }}
                    >
                        <CommentInput
                            file={props.file}
                            isReply
                            hide={closeReplyInput}
                            parent={props.comment.key}
                            closeInput={closeReplyInput}
                            avatarSize="small"
                            videoPlayer={props.videoPlayer}
                            setIsTyping={props.setIsTyping}
                            modern
                        />
                    </Box>
                )}

                {props.replies && props.replies.length > 0 && (
                    <Box
                        sx={{
                            ml: { xs: 2, sm: 3.25 },
                            mt: 1.25,
                            pl: { xs: 1.5, sm: 2 },
                            borderLeft: "2px solid rgba(0, 149, 61, 0.16)",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.75,
                        }}
                    >
                        {props.replies.map((reply) => (
                            <FileComment
                                key={reply.key}
                                file={props.file}
                                comment={reply}
                                isReply
                                avatarSize="small"
                                videoPlayer={props.videoPlayer}
                                setIsTyping={props.setIsTyping}
                                modern
                            />
                        ))}
                    </Box>
                )}

                <Menu
                    id={`comment-menu-${props.comment.key}`}
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    {COMMENT_EDITING_ENABLED && (
                        <MenuItem onClick={handleEditButtonPress}>
                            <ListItemIcon>
                                <EditOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            Edit comment
                        </MenuItem>
                    )}
                    <MenuItem
                        onClick={handleDeleteButtonPress}
                        sx={{ color: "error.main" }}
                    >
                        <ListItemIcon sx={{ color: "error.main" }}>
                            <DeleteOutlineIcon fontSize="small" />
                        </ListItemIcon>
                        Delete comment
                    </MenuItem>
                </Menu>
                {confirmDeleteDialogOpen && (
                    <ConfirmDeleteDialog
                        title="Delete comment"
                        message="Are you sure you want to delete this comment?"
                        detail={props.comment.text}
                        open={confirmDeleteDialogOpen}
                        onClose={handleDeleteDialogClose}
                    />
                )}
            </Box>
        );
    }

    return (
        <div className={classes.root}>
            <Container
                fluid
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <Col>
                    {isDeleted ? (
                        <Row>
                            <span className={classes.dateText}>
                                {deletedLabel} &middot; {dateString}
                            </span>
                        </Row>
                    ) : (
                    <Row>
                        <UserAvatar
                            userOrHub={props.comment.userObject}
                            size={props.avatarSize}
                            path="users"
                        />
                        <Col className={classes.textColumn}>
                            <Row>
                                <span className={classes.nameText}>
                                    {props.comment.author}
                                </span>
                                <span className={classes.dateText}>
                                    {dateString}
                                </span>
                            </Row>
                            <Row className={classes.textRow}>
                                {isEditing ? (
                                    <CommentEditForm
                                        value={editText}
                                        onChange={setEditText}
                                        onCancel={handleCancelEdit}
                                        onSave={handleSaveEdit}
                                        onAddTimestamp={
                                            props.videoPlayer
                                                ? handleAddTimestampToEdit
                                                : undefined
                                        }
                                        onTimestampClick={
                                            props.videoPlayer
                                                ? handleSeekClick
                                                : undefined
                                        }
                                        isSaving={isSavingEdit}
                                    />
                                ) : (
                                    segments.map((s) => (
                                        <TextOrLink
                                            key={makeid(5)}
                                            isLink={s.isLink}
                                            text={s.text}
                                            handleSeekClick={handleSeekClick}
                                        />
                                    ))
                                )}
                            </Row>

                            {!props.isReply && !isEditing && (
                                <Row>
                                    <Button
                                        className={classes.replyButton}
                                        color="primary"
                                        size="small"
                                        onClick={handleReplyClick}
                                        fullWidth={true}
                                    >
                                        Reply
                                    </Button>
                                </Row>
                            )}
                        </Col>
                        {canManageComment && !isEditing && (
                            <IconButton
                                className={classes.moreButton}
                                hidden={!isHovering && !menuOpen && !isMobile}
                                onClick={handleMenuClick}
                                size="large"
                            >
                                <MoreVertIcon />
                            </IconButton>
                        )}
                    </Row>
                    )}
                    {isReplying && (
                        <Row className={classes.replyPadding}>
                            <CommentInput
                                file={props.file}
                                isReply={true}
                                hide={closeReplyInput}
                                parent={props.comment.key}
                                closeInput={closeReplyInput}
                                avatarSize={"small"}
                                videoPlayer={props.videoPlayer}
                                setIsTyping={props.setIsTyping}
                            />
                        </Row>
                    )}
                </Col>
            </Container>
            <Container fluid>
                <Col>
                    {props.replies !== undefined &&
                        props.replies.map((r) => (
                            <Row className={classes.replyPadding} key={r.key}>
                                <FileComment
                                    comment={r}
                                    isReply={true}
                                    avatarSize={"small"}
                                    videoPlayer={props.videoPlayer}
                                />
                            </Row>
                        ))}
                </Col>
            </Container>
            <Menu
                id="comment-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                {COMMENT_EDITING_ENABLED && (
                    <MenuItem onClick={handleEditButtonPress}>
                        <ListItemIcon>
                            <EditOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        Edit comment
                    </MenuItem>
                )}
                <MenuItem
                    onClick={handleDeleteButtonPress}
                    sx={{ color: "error.main" }}
                >
                    <ListItemIcon sx={{ color: "error.main" }}>
                        <DeleteOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    Delete comment
                </MenuItem>
            </Menu>
            {confirmDeleteDialogOpen && (
                <ConfirmDeleteDialog
                    title="Delete comment"
                    message="Are you sure you want to delete this comment?"
                    detail={props.comment.text}
                    open={confirmDeleteDialogOpen}
                    onClose={handleDeleteDialogClose}
                />
            )}
        </div>
    );
}

function TextOrLink(props) {
    function handleClick(event) {
        event.preventDefault();

        props.handleSeekClick(props.text);
    }

    return (
        <>
            {props.isLink ? (
                props.modern ? (
                    <Button
                        size="small"
                        startIcon={<PlayCircleOutlineIcon />}
                        onClick={handleClick}
                        sx={{
                            minWidth: 0,
                            mx: 0.25,
                            px: 0.9,
                            py: 0.1,
                            verticalAlign: "baseline",
                            borderRadius: 4,
                            backgroundColor: "rgba(0, 149, 61, 0.08)",
                            "&:hover": {
                                backgroundColor: "rgba(0, 149, 61, 0.14)",
                            },
                        }}
                    >
                        {props.text}
                    </Button>
                ) : (
                    <Link
                        onClick={handleClick}
                        style={{
                            cursor: "pointer",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        {props.text}
                    </Link>
                )
            ) : (
                <Typography
                    component="span"
                    variant={props.modern ? "body2" : "inherit"}
                    sx={{ whiteSpace: "pre-wrap" }}
                >
                    {props.text}
                </Typography>
            )}
        </>
    );
}
